module.exports = __webpack_public_path__ + "static/gallery-10-0a823ed543102b2a29aa0d0448d7e9ed.jpg";